import Component from "./sort.umd.min.js";

Component.install = function (Vue) {
  Vue.component("Sort", Component);
};

export default Component;
